<template>
  <main class="min-h-screen flex relative lg:static surface-ground">

    <Toast />

    <div class="min-h-screen flex flex-column relative flex-auto">
      <!-- <TopBar :title="topBarTitle"></TopBar> -->

      <PageContent>
        <router-view />
      </PageContent>
    </div>

    <!-- <Dialog class="resume-dialog popup-dialog text-center" :modal="true" :dismissableMask="true"
      v-model:visible="showResume">

      <h2 class="resume-dialog-header">Resume</h2>

      <div>
        <p>Would you like to resume where you left off?</p>
      </div>

      <template #footer>
        <Button label="No" @click="showResume = false" class="p-button-text text-only" />
        <Button label="Yes" @click="doResume" />
      </template>
    </Dialog> -->

    <ScrollTop />

  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
// import { router } from '@/router';

import { useAppStore } from "@/stores/app";
// import { useUserStore } from '@/stores/user';

// import TopBar from '@/components/layout/TopBar.vue';
import PageContent from '@/components/layout/PageContent.vue';
// import { updateDocumentTitle } from './utils';

// Variables =================================

const appStore = useAppStore();

// const showResume = ref(false);
// let storedPath = '';

// const pageName = ref('');

// const topBarTitle = 'Title here';

// Methods ===============================

// async function checkForResume() {
//   const userStore = useUserStore();

//   try {
//     const state: any = await userStore.getBookmark();
//     console.log('retrieved state:', state);

//     userStore.$state = state;

//   } catch (error) {
//     console.error('error retrieving bookmark:', error);
//   }



//   const { fullPath, name } = userStore.route;

//   // TODO: figure out path names for dynamic routes
//   // use the course-data JSON to create map?

//   pageName.value = name;

//   const userPath = fullPath;
//   const path = location.hash.replace('#', '');

//   const pathsplit = path.split('?');

//   const currentPath = pathsplit[0];

//   // if (currentPath === '/') {
//   //   // Home has own button
//   //   return;
//   // }

//   console.log('userPath, currentPath:', userPath, currentPath);

//   if (userPath !== currentPath) {
//     storedPath = userPath;
//     showResume.value = true;
//   }

// }

// function doResume() {
//   console.log('resume to ', storedPath);
//   showResume.value = false;

//   router.replace(storedPath);
// }

// Watch =================================


// Lifecycle =================================

onMounted(async () => {
  appStore.initialized = true;
  // updateDocumentTitle();

  // checkForResume();
});

</script>

<style lang="scss">
@import './styles/styles.scss';
</style>
